import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

const mutateUpdateSafetyChecklistItem = async ({
  checklistId,
  itemId,
  data,
}: {
  checklistId: string;
  itemId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(
    `${SAFETY_CHECKLIST_API}/${checklistId}/items/${itemId}`,
    data
  );
};

const useUpdateSafetyChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      checklistId: string;
      itemId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateSafetyChecklistItem,
    ...queryParams,
  });

export default useUpdateSafetyChecklistItemMutation;
